import { Link } from "react-router-dom";

export const ResourceCard = ({ title, description, icon, to, external }) => (
  <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center hover:shadow-xl transition group border border-gray-100">
    <div className="mb-4 text-4xl text-btn-primary">{icon}</div>
    <h2 className="font-bold text-lg text-center mb-2 text-btn-primary">{title}</h2>
    <p className="text-gray-600 text-center text-sm mb-4">{description}</p>
    {to ? (
      external ? (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-auto inline-block px-4 py-2 rounded-full bg-btn-secondary text-btn-primary font-semibold hover:bg-btn-secondary-hover transition"
        >
          Learn More
        </a>
      ) : (
        <Link
          to={to}
          className="mt-auto inline-block px-4 py-2 rounded-full bg-btn-secondary text-btn-primary font-semibold hover:bg-btn-secondary-hover transition"
        >
          Learn More
        </Link>
      )
    ) : null}
  </div>
);
